<template>
    <div id="upgrades" class="mt-8 border-t border-gray-200 pt-8">
        <div>
            <h3 class="text-2xl leading-6 font-medium text-indigo-600">
                {{ trans('Boost your listing') }}
            </h3>
        </div>
        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-4">
                <fieldset>
                    <legend id="radiogroup-label" class="sr-only">
                        Make your listing stand out
                    </legend>
                    <ul class="space-y-4" role="radiogroup" aria-labelledby="radiogroup-label">
                        <li v-if="!$page.board.only_paid" @click="selectProduct({id:0})" id="radiogroup-option-0" tabindex="0" role="radio" :aria-checked="selectedProduct == 0 ? 'true' : 'false'" class="group relative bg-white rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-indigo-500">
                            <div class="rounded-lg border border-gray-300 bg-white px-6 py-4 hover:border-gray-400 sm:flex sm:justify-between">
                                <div class="flex items-center">
                                    <div class="text-sm">
                                        <p class="font-medium text-gray-900">
                                            No thanks.
                                        </p>
                                        <div class="text-gray-500">
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                                    <div class="font-medium text-gray-900">{{ formatPrice({price: 0, currency: products[0].currency}) }}</div>
                                </div>
                            </div>
                            <!-- On: "border-indigo-500", Off: "border-transparent" -->
                            <div class="absolute inset-0 rounded-lg border-2 pointer-events-none" :class="selectedProduct == 0 ? 'border-indigo-500': 'border-transparent'" :aria-hidden="selectedProduct == 0 ? 'true' : 'false'"></div>
                        </li>
                        <li v-for="(product, index) in products" @click="selectProduct(product)" :key="product.id" :id="`radiogroup-option-${index + 1}`" tabindex="0" role="radio" :aria-checked="selectedProduct == product.id ? 'true' : 'false'" class="group relative bg-white rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-indigo-500">
                            <div class="rounded-lg border border-gray-300 bg-white px-6 py-4 hover:border-gray-400 sm:flex sm:justify-between">
                                <div class="flex items-center">
                                    <div class="text-sm">
                                        <p class="font-medium text-gray-900">
                                            {{ product.description }}
                                        </p>
                                        <div class="text-gray-500">
                                            <template v-for="(feature, index) in product.features">
                                            <p class="sm:inline">{{ feature }}</p>
                                            <span v-if="index != Object.keys(product.features).length - 1" class="hidden sm:inline sm:mx-1" aria-hidden="true">&middot;</span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                                    <div class="font-medium text-gray-900">{{ formatPrice(product) }}</div>
                                </div>
                            </div>
                            <!-- On: "border-indigo-500", Off: "border-transparent" -->
                            <div class="absolute inset-0 rounded-lg border-2 pointer-events-none" :class="selectedProduct == product.id ? 'border-indigo-500': 'border-transparent'" :aria-hidden="selectedProduct == product.id ? 'true' : 'false'"></div>
                        </li>
                    </ul>
                </fieldset>

<!--                <fieldset>-->
<!--                    <legend class="text-base font-medium text-gray-900">-->
<!--                        Make your listing stand out-->
<!--                    </legend>-->
<!--                    <div class="mt-4">-->
<!--                        <div class="flex items-center">-->
<!--                            <input id="free" name="product" v-model="selectedProduct" type="radio" value="0"-->
<!--                                   class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">-->
<!--                            <label for="free" class="ml-3">-->
<!--                                <span class="block text-sm leading-5 font-medium text-gray-700">No thanks</span>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div v-for="product in products" class="mt-4 flex items-center">-->
<!--                            <input :id="`level${product.id}`" name="product" v-model="selectedProduct" type="radio" :value="product.id"-->
<!--                                   class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">-->
<!--                            <label :for="`level${product.id}`" class="ml-3">-->
<!--                                <span class="block text-sm leading-5 font-medium text-gray-700" v-html="formatFeatureDescription(product)"></span>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </fieldset>-->

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PostingUpgrades",
        props: {
            lang: Object | String,
            products: Array
        },
        data() {
            return {
                selectedProduct: this.products[0]?.id || 0
            }
        },
        methods: {
            selectProduct(product) {
                this.selectedProduct = product.id;
            },
            trans(value) {
                if (Object.keys(this.lang).length === 0) {
                    return value;
                }

                return this.lang[value] || value;
            },
            formatFeatureDescription(product) {

                const price = new Intl.NumberFormat('en-US', { style: 'currency', currency: product.currency }).format(product.price / 100);

                return `${product.description} for <strong>${price}</strong>`;

            },
            formatPrice(product) {
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: product.currency }).format(product.price / 100);
            }
        },
        watch: {
            selectedProduct() {
                this.$emit('input', parseInt(this.selectedProduct, 10));
            }
        }
    }
</script>
